import React from 'react';
import { uniqBy } from "lodash";
import { useStoreState, useStoreActions } from "easy-peasy";
import { types } from "../lib/store";
import {useTranslation} from "react-i18next";

function FocusCurve() {
  const { t } = useTranslation();

  const multipleCurves = useStoreState(state => state.selection.fan.multipleCurves);
  const hasDesignPoint = useStoreState(state => state.selection[types.HAS_DESIGN_POINT]);
  const focusedPair = useStoreState(state => state.selection.focusedPair);

  const { curves } = useStoreState(state => state.selection.graph);

  const updateFocusedPair = useStoreActions(actions => actions.selection[types.SET_FOCUSED_PAIR]);

  const updateStore = (e) => {
    e.preventDefault();

    updateFocusedPair(e.target.value);
  };

  return (
    <>
      {
        multipleCurves && !hasDesignPoint &&
        <div className="panel panel-info">
          <div className="panel-heading">
            { t("frontend:fan.focus_curve") }
          </div>
          <div className="panel-body">
            <form className="form-horizontal">
              <select className="form-control" onChange={updateStore} value={focusedPair}>
                <option value="">{ t('frontend:fan.focus_curve') }</option>
                {
                  uniqBy(curves, 'pair_identifier').map(({ pair_identifier }, _index) => {
                    return <option key={pair_identifier} value={pair_identifier}>{pair_identifier}</option>;
                  })
                }
              </select>
            </form>
          </div>
        </div>
      }
    </>
  );
}

export default FocusCurve;
